import { isWebViewBridgeAvailable, setActionBehavior, updateNavigationBar  } from '@tef-novum/webview-bridge';

export class ActionBehavior{
    constructor(title,message,acceptText,cancelText) {
        this.behavior = 'confirm';
        this.title = title;
        this.message = message;
        this.acceptText = acceptText;
        this.cancelText = cancelText;
    }
}

export default class WebViewBridgeService{

    isWebViewBridgeAvailable(){
        return isWebViewBridgeAvailable();
    }

    setActionBehavior(title,message,acceptText,cancelText){
        if(!this.isWebViewBridgeAvailable()){
            return false;
        }
        let webviewClose = new ActionBehavior(title,message,acceptText,cancelText);
        setActionBehavior({webviewClose});
        return true;
    }

    updateNavigationBar(){
        if(!this.isWebViewBridgeAvailable()){
            return;
        }
        updateNavigationBar({
            showBackButton: false
        });
    }


}



// WEBPACK FOOTER //
// ./src/services/WebViewBridgeService.js